import React from "react";
import { Button } from "@myhealth-raccoon/components";

export function UnexpectedError() {
    return <div className="text-center m-auto">
        <h1 className="text-gray-900 font-semibold text-lg mb-2">An error has occurred.</h1>
        <p>Please contact support if the problem persists.</p>

        <Button
            className="mt-8 inline-block"
            href={import.meta.env.VITE_MYHEALTH_WEBSITE}
        >Go to home</Button>
    </div>
}